export default {
    fr: {
        seo: {
            description: 'Soletanche Bachy, filiale de Soletanche Freyssinet (groupe VINCI), est une entreprise générale de fondations et de technologies du sol'
        },
        cookiebanner: {
            description: 'This website uses cookies to ensure you get the best experience',
            more: 'Learn more',
            accept: 'ACCEPT',
            decline: 'DECLINE'
        },
        nav: {
            home: 'accueil',
            direction: 'direction',
            ourdirection: 'notre direction',
            solutions: 'solutions',
            oursolutions: 'nos solutions',
            techniques: 'techniques',
            project: 'réalisation',
            projects: 'réalisations',
            market: 'marché',
            markets: 'marchés',
            news: 'actualités',
            article: 'Actualité',
            contact: 'contact',
            joinus: 'nous rejoindre',
            innovation: 'innovation',
            about: 'A propos',
            findus: 'retrouver nous sur',
            oursub: 'Nos filiales',
            freyssineturl: 'http://www.soletanchefreyssinet.com/fr/',
            legalnotices: 'mentions légales',
            privacypolicy: 'politique de confidentialité',
            termsofuse: 'conditions d\'utilisation',
            credits: 'crédits',
            sitemap: 'plan du site'
        },
        cta: {
            showmore: 'Afficher plus',
            backtohome: 'Accueil',
            contact: {
                baseline: '50 pays d’implantation'
            },
            xp: {
                title: 'La ville sous la ville',
                baseline: 'Découvrez le monde Soletanche Bachy',
                explore: 'Explorer',
            },
            close: 'Fermer',
            more: {
                projects: 'Voir plus de réalisations'
            },
            see: {
                project: 'Voir cette réalisation',
                technique: 'Voir cette technique'
            },
            download: {
                document: 'Télécharger ce document'
            },
            contactus: 'Nous contacter',
            share: 'Partager'
        },
        footer: {
            text: 'Soletanche Bachy est le leader mondial des fondations et des technologies du sol et intervient dans 60 pays à travers un réseau de 80 filiales et agences. Maîtrisant l’ensemble des procédés géotechniques, le Groupe propose des solutions innovantes et performantes en tant qu’ensemblier ou spécialiste dans le cadre de projets clés en main à dominante géotechnique ou de travaux de spécialité.'
        },
        common: {
            relatedtechniques: 'Techniques relatives',
            relatedprojects: 'Chantiers relatifs',
            implementationmethods: 'Méthodes d’exécution',
            country: 'Pays',
            project: 'Réalisation',
            market: 'Marché',
            markets: 'Marchés',
            workperiod: 'Durée des travaux',
            grouping: 'Groupement',
            projectowner: 'Maître d’ouvrage',
            projectmanager: 'Maître d’oeuvre ',
            pagenotfound: 'Page non trouvée',
            context: 'Contexte',
            aboutus: 'Nous connaitre',
            ourwork: 'Notre travail',
            contactus: 'Nous contacter',
            filterby: 'Filtrer par',
            categories: 'Catégories',
            reduce: 'Réduire',
            narrative: 'Histoire',
            asubsidiaryof: 'une société de',
            location: 'Localisation',
            specializedsubsidiaries: 'Filiales spécialisées'
        }
    },
    en: {
        seo: {
            description: 'Soletanche Bachy, a subsidiary of Soletanche Freyssinet (VINCI group), is a general contractor for foundations and soil technologies.'
        },
        cookiebanner: {
            description: 'This website uses cookies to ensure you get the best experience',
            more: 'Learn more',
            accept: 'ACCEPT',
            decline: 'DECLINE'
        },
        nav: {
            home: 'home',
            direction: 'leadership',
            ourdirection: 'our leadership',
            solutions: 'solutions',
            oursolutions: 'our solutions',
            techniques: 'techniques',
            project: 'project',
            projects: 'projects',
            market: 'market',
            markets: 'markets',
            news: 'news',
            article: 'Article',
            contact: 'contact',
            joinus: 'join us',
            innovation: 'innovation',
            about: 'about us',
            legalnotices: 'legal notices',
            privacypolicy: 'privacy policy',
            termsofuse: 'terms of use',
            findus: 'find us on',
            oursub: 'Our subsidiaries',
            freyssineturl: 'http://www.soletanchefreyssinet.com/',
            credits: 'Credits',
            sitemap: 'Sitemap'
        },
        cta: {
            showmore: 'More',
            backtohome: 'Back to home',
            contact: {
                baseline: '50 local<br/>chapters'
            },
            xp: {
                title: 'A world\nunderground',
                baseline: 'Discover the world of Soletanche Bachy',
                explore: 'Explore',
            },
            close: 'Close',
            more: {
                projects: 'See more projects'
            },
            see: {
                project: 'See this project',
                technique: 'See this technique'
            },
            download: {
                document: 'Download document'
            },
            contactus: 'Contact us',
            share: 'Share'
        },
        footer: {
            text: 'Soletanche Bachy is a world leader in foundations and soil technologies, operating in 60 countries via a network of 80 subsidiaries and branches. The Group delivers the full range of geotechnical processes and provides innovative, effective solutions as either a lead or specialist contractor for turnkey projects with a geotechnical focus or specialist works.'
        },
        common: {
            relatedtechniques: 'Related techniques',
            relatedprojects: 'Related projects',
            implementationmethods: ' Implementation methods',
            country: 'Country',
            project: 'Project',
            market: 'Market',
            markets: 'Markets',
            workperiod: 'Work period',
            grouping: 'Grouping',
            projectowner: 'Project owner',
            projectmanager: 'Project manager',
            pagenotfound: 'Page not found',
            context: 'Context',
            aboutus: 'About us',
            ourwork: 'Our work',
            contactus: 'Contact us',
            filterby: 'Filter by',
            categories: 'Categories',
            reduce: 'Reduce',
            narrative: 'Narrative',
            asubsidiaryof: 'a subsidiary of',
            location: 'location',
            specializedsubsidiaries: 'Specialized subsidiaries'
        }
    },
    es: {
        seo: {
            description: 'Soletanche Bachy, filial de Soletanche Freyssinet (grupo VINCI), es contratista general de cimentaciones y tecnologías de suelos.'
        },
        cookiebanner: {
            description: 'This website uses cookies to ensure you get the best experience',
            more: 'Learn more',
            accept: 'ACCEPT',
            decline: 'DECLINE'
        },
        nav: {
            home: 'portada',
            direction: 'dirección',
            ourdirection: 'nuestra dirección',
            solutions: 'soluciones',
            oursolutions: 'nuestras soluciones',
            techniques: 'técnicas',
            project: 'proyecto',
            projects: 'proyectos',
            market: 'mercado',
            markets: 'mercados',
            news: 'noticias',
            article: 'Noticia',
            contact: 'contacto',
            joinus: 'Únase a nosotros',
            innovation: 'novedad',
            about: 'quiénes somos',
            legalnotices: 'menciones legales',
            privacypolicy: 'política de privacidad',
            termsofuse: 'condiciones de uso',
            findus: 'encuéntranos',
            oursub: 'nuestras filiales',
            freyssineturl: 'http://www.soletanchefreyssinet.com/es/',
            credits: 'Créditos',
            sitemap: 'Mapa del sitio'
        },
        cta: {
            showmore: 'Más',
            backtohome: 'Portada',
            contact: {
                baseline: '50 capítulos<br/>locales'
            },
            xp: {
                title: 'La ciudad bajo la ciudad',
                baseline: 'Comienza un viaje subterráneo para descubrir las actividades de Soletanche Bachy',
                explore: 'Explorar',
            },
            close: 'Cerrar',
            more: {
                projects: 'Ver más proyectos'
            },
            see: {
                project: 'Ver este proyecto',
                technique: 'Ver esta técnica'
            },
            download: {
                document: 'Descargar documento'
            },
            contactus: 'Contáctenos',
            share: 'Compartir'
        },
        footer: {
            text: 'Soletanche Bachy es el líder mundial en materia de cimentaciones y de tecnologías del suelo e interviene en cerca de 60 países a través de una red de 80 filiales y agencias. El Grupo domina toda la gama de procedimientos geotécnicos y propone soluciones innovadoras y eficientes como gestor de proyectos o especialista en el marco de proyectos llave en mano con dominante geotécnica u obras especializadas.'
        },
        common: {
            relatedtechniques: 'Técnicas relacionadas',
            relatedprojects: 'Proyectos relacionados',
            implementationmethods: 'Métodos de implementación',
            country: 'País',
            project: 'Proyecto',
            market: 'Mercado',
            markets: 'Mercados',
            workperiod: 'Período de trabajo',
            grouping: 'Agrupación',
            projectowner: 'Propietario del proyecto',
            projectmanager: 'Gestor de proyectos',
            pagenotfound: 'Página no encontrada',
            context: 'Contexto',
            aboutus: 'Quiénes somos',
            ourwork: 'Nuestro trabajo',
            contactus: 'Contáctenos',
            filterby: 'Filtrar por',
            categories: 'Categorías',
            reduce: 'Reducir',
            narrative: 'Narración',
            asubsidiaryof: 'una empresa de',
            location: 'localización',
            specializedsubsidiaries: 'Filiales spécialisées'
        }
    }
}